export default __webpack_public_path__ + "static/media/selectPort.f16c0631.png";